module.exports = __webpack_public_path__ + "static/img/go_back.4e5e690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/go_back.png
// module id = jc8a
// module chunks = 4